export default "__VITE_ASSET__DuO6dr99__"